import React from 'react';
import './MarketplaceFinalCTA.css';

const MarketplaceFinalCTA = ({ onNavigateToBusinessContact, onNavigateToJoinFreelancer, onNavigateToBrowseRFQs }) => {
  return (
    <section className="marketplace-final-cta">
      <div className="final-cta-content">
        {/* Header Section */}
        <div className="cta-header">
          <div className="cta-badge">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
            <span>JOIN THE MOVEMENT</span>
          </div>
          <h2>South Africa's Freelance Economy is Thriving</h2>
          <p className="cta-intro">
            With youth unemployment at historic highs, thousands of South Africans are turning to 
            freelancing for flexible income. Whether you're building a side hustle or running a 
            full-time freelance business, there's opportunity here.
          </p>
        </div>

        {/* Split Layout */}
        <div className="cta-grid">
          {/* Freelancer Side */}
          <div className="cta-section cta-freelancer">
            <div className="section-label">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
              <span>For Freelancers</span>
            </div>

            <h3>Turn Your Skills Into Income</h3>
            
            <p className="section-description">
              No more waiting tables or sending CVs into the void. Browse real projects from verified 
              businesses, showcase your skills, and earn on your schedule.
            </p>

            <div className="benefits-list">
              <div className="benefit-row">
                <div className="benefit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <div className="benefit-content">
                  <h4>No Formal Qualifications</h4>
                  <p>Students, self-taught pros, and career freelancers all welcome</p>
                </div>
              </div>

              <div className="benefit-row">
                <div className="benefit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <div className="benefit-content">
                  <h4>Work From Anywhere</h4>
                  <p>Remote opportunities across all South African provinces</p>
                </div>
              </div>

              <div className="benefit-row">
                <div className="benefit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <div className="benefit-content">
                  <h4>Build Your Reputation</h4>
                  <p>Grow your portfolio with verified projects and client reviews</p>
                </div>
              </div>
            </div>

            <div className="action-group">
              <button className="btn-primary" onClick={onNavigateToBrowseRFQs}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="m21 21-4.35-4.35"/>
                </svg>
                <span>Browse Projects</span>
              </button>
              <button className="btn-secondary" onClick={onNavigateToJoinFreelancer}>
                <span>Create Free Account</span>
              </button>
            </div>
          </div>

          {/* Divider */}
          <div className="vertical-divider">
            <div className="divider-line"></div>
            <div className="divider-badge">OR</div>
            <div className="divider-line"></div>
          </div>

          {/* Business Side */}
          <div className="cta-section cta-business">
            <div className="section-label">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
                <path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/>
              </svg>
              <span>For Businesses</span>
            </div>

            <h3>Hire Skilled South African Talent</h3>
            
            <p className="section-description">
              Skip the recruitment agencies and overpriced consultants. Access a network of skilled 
              freelancers ready to deliver quality work at competitive rates.
            </p>

            <div className="benefits-list">
              <div className="benefit-row">
                <div className="benefit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <div className="benefit-content">
                  <h4>Verified Freelancers</h4>
                  <p>All professionals are screened for quality and reliability</p>
                </div>
              </div>

              <div className="benefit-row">
                <div className="benefit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <div className="benefit-content">
                  <h4>Compare Proposals</h4>
                  <p>Review multiple quotes and portfolios before hiring</p>
                </div>
              </div>

              <div className="benefit-row">
                <div className="benefit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <div className="benefit-content">
                  <h4>Personal Support</h4>
                  <p>Dedicated onboarding and project management assistance</p>
                </div>
              </div>
            </div>

            <div className="action-group">
              <button className="btn-primary" onClick={onNavigateToBusinessContact}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                  <polyline points="17 8 12 3 7 8"/>
                  <line x1="12" y1="3" x2="12" y2="15"/>
                </svg>
                <span>Get Started</span>
              </button>
              <p className="support-note">We'll contact you within 24 hours</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarketplaceFinalCTA;